<div class="tree-container">
  @if (isLoading) {
    <div class="loading-state">
      <ion-spinner name="crescent" color="primary"></ion-spinner>
      <p>{{ 'TREE_LEVEL.LOADING_DATA' | translate }}</p>
    </div>
  } @else if(!field.props['treeData'] && (!field.props['treeAttachment'] || !field.props['treeAttachment'].table)) {
    <div class="no-data-source">
      <h3>{{ 'TREE_LEVEL.NO_DATA_SOURCE_CONFIGURED' | translate }}</h3>
    </div>
  } @else {
    @if(!options.formState.disabled && !field.props['disabled'] && !field.props['readonly']) {
      <div class="tree-content">
        @if(nodes && nodes[0] && !treeState.expandedNodeIds?.[nodes[0]!.id]) {
          <span class="resulting-node-label" (click)="expandRootNode()">
            <app-dynamic-icon name="fa-solid fa-caret-right" class="expand-node-icon" size="small"></app-dynamic-icon>
            @if (selectedNodeId) {
              <span>{{ getLevelAsText() }}</span>
            } @else {
              <span>{{ 'TREE_LEVEL.SELECT_A_NODE  ' | translate }}</span>
            }
          </span>
        } @else {
          <tree-root
            [nodes]="nodes"
            [(state)]="treeState"
            [options]="treeOptions">
            <ng-template #treeNodeWrapperTemplate let-node let-index="index">
              <div class="body-row">
                <div class="node-column">
                  <div class="node-wrapper-outer" [attr.data-level]="node.level">
                    <div class="branch-lines"></div>
                    <div class="node-wrapper" [style.padding-left]="node.getNodePadding()">
                      <tree-node-expander [node]="node"></tree-node-expander>
                      <div class="node"
                        [class.selected-node]="node.id === selectedNodeId"
                        [class.disabled-node]="!canSelectNode(node)"
                        (click)="node.mouseAction('click', $event)"
                        (dblclick)="node.mouseAction('dblClick', $event)"
                        (contextmenu)="node.mouseAction('contextMenu', $event)">
                        <span class="node-name">
                          <tree-node-content [node]="node" [index]="index"></tree-node-content>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </ng-template>
          </tree-root>
        }
      </div>
    } @else {
      <div class="disabled-tree-view">
        {{getLevelAsText()}}
      </div>
    }
  }
</div>